// Human labels for the six skill-zone keys, in all three languages.
//
// These used to live only inside Report13Page's per-language copy blocks, so
// anything else that touched top_skills had nothing to translate with — the
// cabinet printed the raw key, and an Azerbaijani parent read "communication"
// mid-sentence. One dictionary, imported by both.
//
// Six zones, not eight: organizational/empathy were dropped in Phase 1.3 — see
// the SKILL_LABELS_RU comment in src/lib/reports1822.ts.
//
// ⚠️ THIS IS ALSO THE WRITE WHITELIST. api/cabinet/snapshot/save filters
// top_skills against these keys, so a key missing here is not merely
// untranslated — it never reaches the database.
//
// Adding a skill zone: put it HERE FIRST, in all three languages, and ship
// that before the generator starts emitting it. In the other order the new
// zone is dropped on write (logged as an error with the snapshot id, but the
// data is still gone).

export type SkillLang = "ru" | "az" | "en";

export const SKILL_LABELS: Record<SkillLang, Record<string, string>> = {
  ru: {
    analytical: "Аналитическое мышление",
    communication: "Коммуникация",
    creative: "Творческое мышление",
    physical: "Физические навыки",
    technical: "Технические навыки",
    leadership: "Лидерство",
  },
  az: {
    analytical: "Analitik düşüncə",
    communication: "Kommunikasiya",
    creative: "Yaradıcı düşüncə",
    physical: "Fiziki bacarıqlar",
    technical: "Texniki bacarıqlar",
    leadership: "Liderlik",
  },
  en: {
    analytical: "Analytical thinking",
    communication: "Communication",
    creative: "Creative thinking",
    physical: "Physical skills",
    technical: "Technical skills",
    leadership: "Leadership",
  },
};

// Translate stored skill keys, DROPPING anything the dictionary doesn't know.
// Live snapshots contain at least one out-of-vocabulary token ("analysis"),
// and a key that leaks to the screen reads as a broken field — better to show
// one label less than to show a machine token to a parent.
export function skillLabels(keys: readonly string[] | null, lang: SkillLang): string[] {
  const dict = SKILL_LABELS[lang] ?? SKILL_LABELS.ru;
  return (keys ?? []).map((k) => dict[k]).filter((v): v is string => !!v);
}
